module.exports = __webpack_public_path__ + "img/ico_social_x.4ce622a4.svg";